import * as request from "../utils/request"
import "es6-promise/auto"
import * as url from "../utils/url"
import localStorage from "../utils/localStorage"
import Raven from "raven-js"
import { getUserAgent } from "../utils/ua"
import { BUSINESS_TYPE } from "../store/enums"
import _ from "lodash"

export function getStoreConfig() {
  return new Promise((resolve, reject) => {
    getStoreConfigSource()
      .then(storeConfig => {
        let pf = url.getParam("pf")
        let storeConfigCopy = _.cloneDeep(storeConfig)
        if (pf && checkWhiteListPf(pf, storeConfigCopy.block_ios_app_pfs)) {
          let userAgent = getUserAgent()
          let system = userAgent.iOS ? "ios" : "android"
          // 备注：这里不方便使用登录态，而且需要屏蔽的目前都是iOS手Q/微信，所以这里暂定使用ua作为手Q和微信的判断，可改为登录态
          let channel = userAgent.weixin ? "wx" : "qq"
          storeConfigCopy.itemList.forEach(item => {
            if (item && item.busList) {
              item.busList = item.busList.filter(bus => {
                // 手游：只可以展示预约状态的
                // 包月：只可以展示游戏(端游)包月
                if (bus.categoryId == BUSINESS_TYPE.MONTH) {
                  return bus.shopCategories && bus.shopCategories.indexOf("game") > -1
                } else if (bus.categoryId == BUSINESS_TYPE.MOBILE_GAME) {
                  return bus[system] && bus[system][channel] && bus[system][channel].status === 2
                } else {
                  return true
                }
              })
            }
          })
        }
        resolve(storeConfigCopy)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export function getStoreConfigSource() {
  return new Promise((resolve, reject) => {
    if (window.__midasStaticConfig_wechat_store) {
      resolve(window.__midasStaticConfig_wechat_store)
    } else {
      let storeConfigEnv = url.getParam("store_config_env")
      if (storeConfigEnv > 0) {
        //有沙箱参数始终从沙箱地址读取配置台文件
        request
          .getScript(`//sandbox.pay.qq.com/h5/store_config/wechat_store/wechat_store.js?timestamp=${+new Date()}`)
          .then(() => {
            resolve(window.__midasStaticConfig_wechat_store)
          })
          .catch(e => {
            reject(e)
          })
      } else {
        window.WECHAT_STORE_CONFIG_START_TIME = +new Date()
        if (window.WECHAT_STORE_CONFIG_VERSION) {
          let config = localStorage.get("midas_wechat_store_config", true)
          if (config && config.md5Version == window.WECHAT_STORE_CONFIG_VERSION) {
            window.WECHAT_STORE_CONFIG_END_TIME = +new Date()
            resolve((window.__midasStaticConfig_wechat_store = config))
          } else {
            request
              .getScript(`//midas.gtimg.cn/store_config/wechat_store.${window.WECHAT_STORE_CONFIG_VERSION}.js`)
              .then(() => {
                window.WECHAT_STORE_CONFIG_END_TIME = +new Date()
                window.__midasStaticConfig_wechat_store.md5Version = window.WECHAT_STORE_CONFIG_VERSION
                localStorage.set("midas_wechat_store_config", JSON.stringify(window.__midasStaticConfig_wechat_store))
                resolve(window.__midasStaticConfig_wechat_store)
              })
              .catch(e => {
                Raven.captureException(new Error("get-md5-store-config-failure"), {
                  tags: { type: "get-md5-store-config-failure" },
                  extra: {
                    e,
                    midasStaticConfig: window.__midasStaticConfig_wechat_store
                  }
                })
                getStoreConfigFromPayUrl(resolve, reject)
              })
          }
        } else {
          getStoreConfigFromPayUrl(resolve, reject)
        }
      }
    }
  })
}

/**
 * 从缓存中读配置
 * 如果配置更新，需要重新请求最新配置并更新缓存
 */
export function getConfigFromLocalStorage({ configUrl, configUrlParam, configVersion, configKey }) {
  return new Promise((resolve, reject) => {
    if (configVersion && configKey) {
      let config = localStorage.get(`midas_wechat_store_config_${configKey}`, true)
      if (config && config.configVersion == configVersion) {
        resolve(config)
      } else {
        getConfigFromPayUrl({ configUrl, configUrlParam })
          .then(config => {
            let configContent = {}
            configContent.content = config
            configContent.configVersion = configVersion
            localStorage.set(`midas_wechat_store_config_${configKey}`, JSON.stringify(configContent))
            resolve(configContent)
          })
          .catch(e => {
            Raven.captureException(new Error("get-config-from-pay-failure"), {
              tags: { type: "get-config-from-pay-failure" },
              extra: {
                e
              }
            })
            reject(e)
          })
      }
    } else {
      getConfigFromPayUrl({ configUrl, configUrlParam })
        .then(config => {
          resolve(config)
        })
        .catch(e => {
          Raven.captureException(new Error("get-config-from-pay-failure"), {
            tags: { type: "get-config-from-pay-failure" },
            extra: {
              e
            }
          })
          reject(e)
        })
    }
  })
}

/**
 * 从pay地址访问配置文件
 * @param {*} param.configUrl
 * @param {*} param.configKey
 */
export function getConfigFromPayUrl({ configUrl, configUrlParam }) {
  if (!configUrl) return Promise.reject("配置链接缺失")
  return request.ajax({
    url: configUrl.trim(),
    data: {
      timestamp: +new Date(),
      ...configUrlParam
    }
  })
}

/**
 * 从原始的pay地址访问配置文件,作为降级方案
 * @param resolve
 * @param reject
 */
function getStoreConfigFromPayUrl(resolve, reject) {
  request
    .getScript(`//pay.qq.com/h5/store_config/wechat_store/wechat_store.js?timestamp=${+new Date()}`)
    .then(() => {
      window.WECHAT_STORE_CONFIG_END_TIME = +new Date()
      resolve(window.__midasStaticConfig_wechat_store)
    })
    .catch(e => {
      Raven.captureException(new Error("get-store-config-from-pay-failure"), {
        tags: { type: "get-store-config-from-pay-failure" },
        extra: {
          e
        }
      })
      reject(e)
    })
}

/**
 * 将配置表中的内容置为 KEY VALUE 形式
 * @returns {*}
 */
const mapKeyValue = storeConfig => {
  if (window.__midasStaticConfig_wechat_store_kv) {
    return window.__midasStaticConfig_wechat_store_kv
  } else {
    let result = {}

    storeConfig.itemList.forEach(group => {
      group.busList.forEach(item => {
        result[`${group.groupId}_${item.busId}`] = item
      })
    })

    window.__midasStaticConfig_wechat_store_kv = result
    return result
  }
}

/**
 * 以 key value 的形式组织 store config
 */
export function getKVStoreConfig() {
  return new Promise((resolve, reject) => {
    getStoreConfig()
      .then(res => {
        resolve(mapKeyValue(res))
      })
      .catch(e => {
        reject(e)
      })
  })
}

/**
 * 是否在白名单pf内
 * @param pf 当前pf
 * @param whitelistPf 白名单pf
 * @returns {boolean}
 */
export function checkWhiteListPf(pf, whitelistPf) {
  let ua = getUserAgent()
  return (
    ua.iOS &&
    whitelistPf &&
    whitelistPf.length &&
    whitelistPf.filter(item => {
      return new RegExp(item).test(pf)
    }).length > 0
  )
}

/**
 * 获取不同source的配置信息
 * @param {*} storeConfig
 * @param {*} pfSource
 * @returns
 */
export function getSourceConfig(storeConfig = {}, pfSource = "") {
  if (!storeConfig.pf_map_to_source || !storeConfig.pf_map_to_source.length) {
    storeConfig.pf_map_to_source = []
  }
  return storeConfig.pf_map_to_source.filter(pfSourceMap => {
    return pfSource == pfSourceMap.source
  })[0]
}

/**
 * 判断业务是否要被过滤掉
 * @param {*} bizItem
 * @returns true 要被过滤
 */
export function checkFilterStoreConfigBiz(bizItem) {
  // 过滤 屏蔽商店内展示（下线）的业务
  if (bizItem?.disableTxczShopStatus * 1 === 1) {
    return true
  }

  return false
}
